document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.social-block__inner-box-slider');

  if (slider) {
    new Splide(slider, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      perPage: 9,
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: 0.5,
      },
      breakpoints: {
        980: {
          perPage: 6,
        }
      }
    }).mount(window.splide.Extensions);
  }
});
